// SeloSucesso.js — Selo de confirmação que se desenha ao aparecer.
//
// Fecha a jornada de compra: até aqui o site avisava o sucesso com um ícone
// estático, do mesmo tamanho e peso de qualquer outro ícone da página. Depois
// de pagar, a pessoa precisa de um sinal inequívoco de que deu certo.
//
// O "check" é um path SVG animado por pathLength — o traço se desenha, em vez
// de aparecer pronto. Com reduced-motion o selo aparece completo, sem desenho.
import React from "react";
import { m, useReducedMotion } from "motion/react";

const SeloSucesso = ({ tamanho = 56, className = "" }) => {
  const reduzirMovimento = useReducedMotion();

  return (
    <m.span
      className={"inline-flex items-center justify-center rounded-full bg-emerald-500/15 " + className}
      style={{ width: tamanho, height: tamanho }}
      initial={reduzirMovimento ? { opacity: 0 } : { scale: 0.6, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={
        reduzirMovimento
          ? { duration: 0.2 }
          : { type: "spring", stiffness: 320, damping: 18 }
      }
      aria-hidden="true"
    >
      <svg width={tamanho * 0.55} height={tamanho * 0.55} viewBox="0 0 24 24" fill="none">
        <m.path
          d="M4 12.5 L9.5 18 L20 6.5"
          stroke="rgb(52 211 153)"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={reduzirMovimento ? { pathLength: 1 } : { pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: reduzirMovimento ? 0 : 0.45, delay: reduzirMovimento ? 0 : 0.12, ease: "easeOut" }}
        />
      </svg>
    </m.span>
  );
};

export default SeloSucesso;
